import React, { useState } from 'react';
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Button,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import leftArrow from "../../../assests/leftArrow.svg";
import Sidebar from '../../Navigation/Sidebar/Sidebar';

// Build initial time slot state with null values
const buildInitialSlotState = () => ({
  isTimeSlot: true,
  ...Array.from({ length: 24 }, (_, i) => {
    const start = String(i).padStart(2, '0');
    const end = String((i + 1) % 24).padStart(2, '0');
    return { [`${start}-${end}`]: null };
  }).reduce((acc, curr) => ({ ...acc, ...curr }), {})
});

const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));

const CouponTimePicker = ({

handleBackStep,
finalData,
timePairs,
setTimePairs,
setFinalData,
updatePair,
addPair,
removePair,
buildFinalObject,
couponCreationStep6,
handleBackStep6,
active,
setActive

}) => {
  //const [timePairs, setTimePairs] = useState([{ start: '00', end: '01' }]);
  //const [finalData, setFinalData] = useState(null);

/*   const updatePair = (index, field, value) => {
    const updated = [...timePairs];
    updated[index][field] = value;

    if (field === 'start') {
      const autoEnd = String((parseInt(value) + 1) % 24).padStart(2, '0');
      updated[index].end = autoEnd;
    }

    setTimePairs(updated);
  }; */

/*   const addPair = () => {
    setTimePairs([...timePairs, { start: '00', end: '01' }]);
  }; */

 /*  const removePair = (index) => {
    const updated = [...timePairs];
    updated.splice(index, 1);
    setTimePairs(updated);
  }; */

  /* const buildFinalObject = () => {
    const base = buildInitialSlotState();
    timePairs.forEach(({ start, end }) => {
      const key = `${start}-${end}`;
      if (base.hasOwnProperty(key)) {
        base[key] = true;
      }
    });
    return base;
  };
 */
  
  const navigate = useNavigate();
    const handleClick = () => {
    navigate("/");
  };

  const goback = () => {
    navigate(-1);
  };

 
  return (
    <div className="main-div">
      <div>
        <Sidebar />
      </div>

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Coupon
          </h2>
        </div>
       <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
      Is it only applicable for particular time slot
      </Typography>
          <div className={`half-border-box ${active}`} data-active={active}>
          <button
            className={`yes-button ${active === 'yes' ? 'active' : ''}`}
            onClick={() => setActive('yes')}
            data-tooltip="Select Yes"
          >
            Yes
          </button>
          <button
            className={`no-button ${active === 'no' ? 'active' : ''}`}
            onClick={() => setActive('no')}
            data-tooltip="Select No"
          >
            No
          </button>
        </div>

{active=="yes"&&<div >
      <Box
        sx={{
          maxHeight: 320,
          overflowY: 'auto',
          pr: 1,
          mb: 2,
          border: '1px solid #ccc',
          borderRadius: 2,
          p: 2
        }}
      >
        

        {timePairs.map((pair, index) => (
          <Box
            key={index}
            sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}
          >
            <FormControl fullWidth>
              <InputLabel id={`start-label-${index}`}>Start</InputLabel>
              <Select
                labelId={`start-label-${index}`}
                value={pair.start}
                label="Start"
                onChange={(e) => updatePair(index, 'start', e.target.value)}
              >
                {hours.map((h) => (
                  <MenuItem key={h} value={h}>
                    {h}:00


                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id={`end-label-${index}`}>End</InputLabel>
              <Select
                labelId={`end-label-${index}`}
                value={pair.end}
                label="End"
                //onChange={(e) => updatePair(index, 'end', e.target.value)}
              >
                {hours.map((h) => (
                  <MenuItem
                    key={h}
                    value={h}
                   // disabled={parseInt(h) <= parseInt(pair.start)}
                  >
                    {h}:00
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {timePairs.length > 1 && (
              <IconButton onClick={() => removePair(index)} color="error">
                <DeleteIcon />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>

<div style={{display:"flex",justifyContent:"end"}}>
      <Button onClick={addPair} variant="outlined" sx={{ mb: 2 }}>
        + Add Time Slot
      </Button>
</div>
     <Box className="usersrolebtn">
                <Button className="backbtn" onClick={goback}>
                  Cancel
                </Button>


                <Button
            variant="contained"
           onClick={(e)=>{couponCreationStep6(e)}}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
              </Box>
       

      {finalData && (
        <Box sx={{ background: '#f9f9f9', p: 2, mt: 3, borderRadius: 1 }}>
          <Typography variant="subtitle1">Resulting Payload:</Typography>
          <pre style={{ fontSize: '12px' }}>
            {JSON.stringify(finalData, null, 2)}
          </pre>
        </Box>
      )}
      {timePairs.length > 0 && (
  <Box
    sx={{
      backgroundColor: '#f7f7f7',
      padding: '12px 16px',
      borderRadius: '12px',
      fontSize: '14px',
      color: '#555',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      mt: 2,
      mb: 2,
    }}
  >
    Time Slots Added:{' '}
    {timePairs
      .map(
        ({ start, end }) =>
          `${parseInt(start)}:00–${parseInt(end)}:00`
      )
      .join(', ')}
  </Box>
)}
</div>}
{active=="no"&&  <Box className="usersrolebtn">
                <Button className="backbtn" onClick={goback}>
                  Cancel
                </Button>

          

                         <Button
            variant="contained"
           onClick={(e)=>{couponCreationStep6(e,false)}}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
              </Box>
       }

    </Box>
      </div>
    </div>

   
  );
};

export default CouponTimePicker;
